import React from 'react';
import { Col, Form, FormGroup, FormText, Label, Input, ModalBody, Row, FormFeedback, ModalFooter, Button } from 'reactstrap';
import { ModalButtonCancel } from '../../constant';

export const FormPayMethods = (props) => {

    const {
        toggle, loading, handleInputChange, validaciones, methodAction, name, abbreviation, button
    } = props;

    const {
        name_valid, abbreviation_valid
    } = validaciones;

    return (
        <Form className="" role="form" onSubmit={methodAction}>
            <div className='form-section'>
            <Row>
                <Col md="6">
                    <FormGroup>
                        <Label className="label-admision">Método de pago <span className='f-16' style={{ color: "#0079C7" }}>*</span></Label>
                        <Input
                            type="text"
                            autoComplete="off"
                            name="name" value={name}
                            invalid={name_valid}
                            onChange={handleInputChange}
                            className="input-admision"
                        />
                        <FormFeedback>Debe contener 3 o más caracteres</FormFeedback>
                    </FormGroup>
                </Col>
                <Col>
                    <FormGroup>
                        <Label className="label-admision">Abreviación <span className='f-16' style={{ color: "#0079C7" }}>*</span></Label>
                        <Input
                            type="text"
                            autoComplete="off"
                            name="abbreviation"
                            value={abbreviation}
                            invalid={abbreviation_valid}
                            onChange={handleInputChange}
                            className="input-admision"
                        />
                        <FormFeedback>Debe contener 3 o más caracteres</FormFeedback>
                    </FormGroup>
                </Col>
            </Row>
            </div>
           
        </Form>
    )
}
